import React, { Fragment } from "react";
import { Button, TextLink } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Row, Col, Grid } from "@vds/grids";

export function InternetIDSService(props) {
  return (
    <Grid
      className="OutofFranchise"
      style={{ marginLeft: "3px" }}
      colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
      colGutter={false}
    >
      {(props?.isExternalAppRedirect ? props?.lqQualificationDetails?.IDEQualified == "Y" : props?.addressQualificationDetails?.LQPost?.FiOSDataStatus !==
            "Y" &&  props?.addressQualificationDetails?.Qualified !== "true" && props?.addressQualificationDetails?.IDEQualified  === "Y") ?
             (
        <Row className={`Page-Content ${props.bgForFirst} ${props.isMobileOnly?'mobile':''} ${(props.isTablet) ? 'tablet' : ''}`}>
          <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 9, desktop: 9 }}
          >
            <div className="Main-Title">
              <Title size="large" primitive="h2">
                Internet Dedicated Service
              </Title>
            </div>
            <div></div>
          </Col>

          <Col colSizes={{ mobile: 4, tablet: 5, desktop: 5 }} colGutter={true}>
            <Body size="large" primitive="h2">
              Reliable high performance internet suited to meet the demands of
              cloud technology for businesses in any location.
            </Body>
          </Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col colSizes={{ mobile: 2, tablet: 3, desktop: 3 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Prices start at:
            </Body>
            <Body size="large" primitive="h2">
              Contact sales
            </Body>
        
          </Col>
          <Col colSizes={{ mobile: 2, tablet: 2, desktop: 2 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Speeds start at:
            </Body>
            <Body size="large" primitive="h2">
              10 Mbps (download)
            </Body>
          </Col>

          <Col
            colSizes={{ mobile:4, tablet: 5, desktop: 5 }}
            colGutter={true}
          ></Col>
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col colSizes={{ mobile: 4, tablet: 6, desktop: 6 }} colGutter={true}>
            <Body size="large" primitive="h2" bold={true}>
              Benefits:
            </Body>
            <Body size="large" primitive="h2">
              Security, performance, reliability.
            </Body>
          </Col>
          { props.isMobileOnly ? (<Col
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            colGutter={true}
          ></Col>) : (<Col
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            colGutter={true}
            className="topSpace"
          > 
            <div className="Main-Title">
              <Button
              secondary
              size="large"
              onClick={() => props.history.push("/contact")}
              className={`${props.bgForFirst ? "bgBtn" : "transperentButton"} ${props.isMobileOnly?'button-mobile':''}`}
              >
                Contact Sales 
              </Button>
            </div>
          </Col>)}
          <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
          <Col
            colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
            colGutter={true}
            className="topSpace"
          >
            <Body size="large" primitive="h2" bold={true}>
              Internet Dedicated Service is best for:
            </Body>
            <Body size="large" primitive="h2">
              Small to medium-sized businesses looking for dedicated service in
              low-coverage areas.
            </Body>
          </Col>
          <div className={`gap`}></div>
          { props.isMobileOnly ?(<Col
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            colGutter={true}
            className="topSpace"
          > 
            <div className="Main-Title">
              <Button
              secondary
              size="large"
              onClick={() => props.history.push("/contact")}
              className={`${props.bgForFirst ? "bgBtn" : "transperentButton"} ${props.isMobileOnly?'button-mobile':''}`}
              >
                Contact Sales 
              </Button>
            </div>
          </Col>): (<Col
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            colGutter={true}
          ></Col>)}
          <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            className="topSpace"
          >
          </Col>
        </Row>
      ) : (
        <Fragment></Fragment>
      )}
    </Grid>
  );
}
